<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.103 4.785a9.935 9.935 0 0 1 14.13.34c.248.263.487.536.702.824L12 13.957 4.065 5.949a10.669 10.669 0 0 1 1.038-1.164Zm13.046 1.103A8.558 8.558 0 0 0 12 3.319c-2.336 0-4.514.91-6.15 2.569L12 12.09l6.15-6.202Zm2.407.97-1.612 1.626a3.728 3.728 0 0 1-.463 5.218 3.647 3.647 0 0 1-4.71 0L12 15.488l-1.766-1.781a3.652 3.652 0 0 1-5.173-.467 3.727 3.727 0 0 1 0-4.751l-.827-.834-.785-.797A10.132 10.132 0 0 0 2 12.085c0 5.571 4.477 10.086 10 10.086s10-4.515 10-10.086c.005-1.843-.5-3.653-1.444-5.227Zm-2.379 2.399a2.639 2.639 0 0 1 0 3.205 2.583 2.583 0 0 1-3.644.471l3.644-3.676Zm-8.71 3.68a2.588 2.588 0 0 1-3.177.006 2.64 2.64 0 0 1-.468-3.681l3.645 3.676Z"
      fill="currentColor" />
  </g>
</svg>
